// extracted by mini-css-extract-plugin
module.exports = {"container":"FO","noResults":"GO","contact":"HO"};